import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getUserData = () => connectedStore.applySelector(selectors.getUserData);

export default getUserData;
